module.exports = __webpack_public_path__ + "static/media/bathing.04964788.svg";